import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import styles from "./styles.css";

const Featured = ({ image, title, subtitle, url, className }) => (
  <a href={url} className={cn(styles.container, className)}>
    <img className={styles.image} src={image} alt={title} />
    <div className={styles.text}>
      <div className={styles.title}>{title}</div>
      <div className={styles.subtitle}>{subtitle}</div>
    </div>
  </a>
);

Featured.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  className: PropTypes.string,
};

Featured.defaultProps = {
  className: "",
};

export default Featured;
